import Sans from "@sans-service-tier/sdk";
import { useUserInfo } from "@sans-service-tier/sdk-react";
import { configure, getLoginAdapter } from "@sans-service-tier/sdk-web";
import React from "react";
import { Route, Routes } from "react-router";

import { Authorizer } from "./components/Authorizer";
import Header from "./components/Header";
import { NotFound } from "./routes/NotFound";
import { Landing } from "./routes/Landing";
import { Forbidden } from "./routes/Forbidden";

export default function App() {
  // Init the SANS SDK (this is needed here and in index.tsx to preserve header...)
  try {
    configure(Sans, {
      window,
      initialEnvironment: {
        development: { uri: process.env.REACT_APP_RC_URI },
      },
    });
  } catch (err) {
    console.error(err);
  }

  const loginAdapter = getLoginAdapter();
  const userInfo = useUserInfo();

  return (
    <div className="App">
      <Header userInfo={userInfo} adapter={loginAdapter} />
      <main className="App-body">
        <Routes>
          {/* default/”index” route */}
          <Route index element={<Landing />} />
          <Route path="authorize" element={<Authorizer adapter={loginAdapter} />} />
          <Route path="forbidden" element={<Forbidden />} />

          {/* 404 catch-all */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
    </div>
  );
}
